/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/require-default-props */
import React, { useEffect, useRef, useState } from 'react';
import { Popup } from '@progress/kendo-react-popup';
import { translate } from '@utils/i18n';
import ClickAwayListener from 'react-click-away-listener';
import clsx from 'classnames';
import { useComponentCategories } from '../hooks/useComponentTypesMutations';
import './CategorySelectorStyles.scss';
const namespace = 'features.settings.component_types';
export default function CategorySelector({ value, onChange, onBlur, error, required = false, label = translate('category', { namespace }), variant = 'basic' }) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const anchorRef = useRef(null);
    const { data: availableCategories = [] } = useComponentCategories();
    const handleSelectCategory = (categoryValue) => {
        if (!categoryValue.trim())
            return;
        setDropdownOpen(false);
        onChange(categoryValue);
        onBlur();
    };
    const handleClick = () => {
        setDropdownOpen(true);
    };
    const handleClear = (e) => {
        e.stopPropagation();
        onChange('');
        onBlur();
    };
    return (React.createElement("div", { className: "category-selector" },
        variant === 'basic' ? (React.createElement("div", { className: "qmb-input textInputContainer" },
            React.createElement("input", { ref: anchorRef, type: "text", value: value, onClick: handleClick, readOnly: true, placeholder: " " }),
            React.createElement("label", { className: clsx('qmb-label', { '--required': required }) }, label),
            value && (React.createElement("button", { type: "button", className: "category-selector__clear-button", onClick: handleClear, "aria-label": "Clear category" },
                React.createElement("i", { className: "fa-solid fa-xmark" }))))) : (React.createElement("button", { ref: anchorRef, type: "button", className: "qmb-inedit --dropdown", onClick: handleClick },
            label ? React.createElement(React.Fragment, null,
                label,
                ": ") : '',
            React.createElement("span", { className: "selectValue" }, value || translate('select_category', { namespace })))),
        React.createElement(Popup, { anchor: anchorRef.current, show: dropdownOpen },
            React.createElement(CategoryDropdown, { categories: availableCategories.filter((cat) => cat !== value), onAddCategory: handleSelectCategory, onClosePopup: () => setDropdownOpen(false) })),
        error && React.createElement("span", { className: "category-selector__error" }, error)));
}
function CategoryDropdown({ onAddCategory, onClosePopup, categories }) {
    const searchRef = useRef(null);
    const [filteredCategories, setFilteredCategories] = useState([]);
    useEffect(() => {
        var _a;
        (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        setFilteredCategories(categories);
    }, [categories]);
    const onHandleKeyUp = (event) => {
        if (event.key === 'Enter') {
            onAddCategory(event.target.value);
        }
        else {
            setFilteredCategories(categories.filter((cat) => cat.toLowerCase().startsWith(event.target.value.toLowerCase())));
        }
    };
    return (React.createElement(ClickAwayListener, { onClickAway: onClosePopup },
        React.createElement("div", { className: "category-dropdown" },
            React.createElement("div", { className: "qmb-input--blank" },
                React.createElement("input", { ref: searchRef, onKeyUp: onHandleKeyUp, placeholder: translate('search_or_create', { namespace }) })),
            React.createElement("div", { className: "category-dropdown__list" },
                filteredCategories.length === 0 && (React.createElement(NoMatch, { onHandleClick: () => {
                        var _a, _b;
                        if ((_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.value.trim()) {
                            onAddCategory((_b = searchRef.current) === null || _b === void 0 ? void 0 : _b.value);
                        }
                    } })),
                filteredCategories.length > 0 &&
                    filteredCategories.map((cat) => React.createElement(DropdownItem, { key: cat, value: cat, onHandleClick: onAddCategory }))))));
}
function DropdownItem({ value, onHandleClick }) {
    return (React.createElement("button", { className: "qmb-control", type: "button", onClick: () => onHandleClick(value) }, value));
}
function NoMatch({ onHandleClick }) {
    return (React.createElement("button", { className: "qmb-control", type: "button", onClick: onHandleClick },
        translate('create_new_category', { namespace }),
        React.createElement("i", { className: "fa-light fa-turn-down-left" })));
}
